/**
 * Created by jcorrea on 11/08/17.
 */
angular
	.module('servicepro.selectworker', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);